var map = {
	"./E@2x.png": 162,
	"./ENE@2x.png": 163,
	"./ESE@2x.png": 164,
	"./N@2x.png": 165,
	"./NE@2x.png": 166,
	"./NNE@2x.png": 167,
	"./NNW@2x.png": 168,
	"./NW@2x.png": 169,
	"./S@2x.png": 170,
	"./SE@2x.png": 171,
	"./SSE@2x.png": 172,
	"./SSW@2x.png": 173,
	"./SW@2x.png": 174,
	"./W@2x.png": 175,
	"./WNW@2x.png": 176,
	"./WSW@2x.png": 177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 161;